// Round / match banners and the interact prompt with its progress bar.

import { div, play, span } from "./dom";
import { clamp01 } from "./format";

const BANNER_MS = 3200;
const BANNER_FRAMES: Keyframe[] = [
  { opacity: 0, transform: "translateY(-12px) scale(0.94)" },
  { opacity: 1, transform: "translateY(0) scale(1)", offset: 0.07 },
  { opacity: 1, transform: "translateY(0) scale(1)", offset: 0.82 },
  { opacity: 0, transform: "translateY(-6px) scale(1)" },
];
const BANNER_OPTS: KeyframeAnimationOptions = { duration: BANNER_MS, easing: "cubic-bezier(0.2, 0.7, 0.2, 1)" };

export class Banner {
  readonly root = div("hud-banner");
  private readonly titleEl = div("hud-banner__title");
  private readonly subEl = div("hud-banner__sub");

  constructor() {
    this.root.append(this.titleEl, this.subEl);
    this.root.hidden = true;
  }

  show(title: string, sub: string | undefined, tone: "neutral" | "good" | "bad"): void {
    this.root.dataset.tone = tone;
    this.titleEl.textContent = title;
    this.subEl.textContent = sub ?? "";
    this.subEl.hidden = !sub;
    this.root.hidden = false;
    const anim = play(this.root, BANNER_FRAMES, BANNER_OPTS);
    anim.onfinish = () => {
      this.root.hidden = true;
    };
  }
}

export class InteractPrompt {
  readonly root = div("hud-interact");
  private readonly textEl = span("hud-interact__text");
  private readonly fill = span("hud-interact__fill");
  private readonly bar = div("hud-interact__bar");
  private prompt: string | null = null;
  private prog = -2;

  constructor() {
    this.bar.append(this.fill);
    this.root.append(this.textEl, this.bar);
    this.root.hidden = true;
  }

  set(prompt: string | null, progress: number | null): void {
    const prog = progress === null ? -1 : Math.round(clamp01(progress) * 200) / 200;
    if (prompt === this.prompt && prog === this.prog) return;
    if (prompt !== this.prompt) {
      this.prompt = prompt;
      this.textEl.textContent = prompt ?? "";
      this.textEl.hidden = prompt === null;
    }
    if (prog !== this.prog) {
      this.prog = prog;
      this.bar.hidden = prog < 0;
      if (prog >= 0) this.fill.style.transform = `scaleX(${prog})`;
    }
    this.root.hidden = prompt === null && prog < 0;
  }
}
